/* =============================================================================
   Mundo TEC · barra de envio gratis + cuotas DENTRO del cajon lateral
   -----------------------------------------------------------------------------
   La tienda usa cart_type = drawer: al agregar algo se abre el cajon lateral y
   casi nadie llega a la pagina /cart. El modulo del carrito vivia solo en esa
   pagina, asi que en la practica no lo veia nadie.

   El cajon lo pinta `snippets/cart-drawer.liquid`, 39 KB del tema base. En vez
   de editarlo, este script INYECTA el bloque en el DOM del cajon y lo mantiene
   al dia. Elixira re-renderiza el cajon entero en cada cambio del carrito, asi
   que hay un MutationObserver que vuelve a inyectarlo cuando desaparece.

   El total sale siempre de /cart.js, no del DOM: leer el precio de la pantalla
   obliga a parsear moneda y se rompe con descuentos.

   Config: window.MT_DRAWER = { umbral: <centimos>, cuotas: <n> }
   ========================================================================== */
(function () {
  'use strict';

  var cfg = window.MT_DRAWER || {};
  var UMBRAL = cfg.umbral || 14900;
  var CUOTAS = cfg.cuotas || 6;
  var MARCA = 'data-mt-drawer-goal';

  function money(centimos) {
    return 'S/ ' + (centimos / 100).toFixed(2);
  }

  function contenido(total) {
    var pct = Math.min(100, Math.round((total * 100) / UMBRAL));
    var ok = total >= UMBRAL;
    var msg = ok
      ? '<strong>Tienes envío gratis en Lima</strong> y 3 o ' + CUOTAS +
        ' cuotas sin interés.'
      : 'Te faltan <strong>' + money(UMBRAL - total) + '</strong> para el envío gratis en Lima y las ' +
        'cuotas sin interés.';

    return {
      ok: ok,
      html:
        '<p class="mt-cart__msg">' + msg + '</p>' +
        '<div class="mt-cart__track"><span class="mt-cart__fill" style="width:' + pct + '%"></span></div>'
    };
  }

  function inyectar(total) {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon || cajon.classList.contains('is-empty')) return;

    var inner = cajon.querySelector('.drawer__inner');
    if (!inner) return;

    var caja = cajon.querySelector('[' + MARCA + ']');
    if (!caja) {
      caja = document.createElement('div');
      caja.setAttribute(MARCA, '');
      caja.className = 'mt-cart__goal mt-cart__goal--drawer';
      // Debajo del encabezado: es lo primero que se mira al abrir el cajon.
      var header = inner.querySelector('.drawer__header');
      if (header && header.parentNode === inner) {
        header.insertAdjacentElement('afterend', caja);
      } else {
        inner.insertAdjacentElement('afterbegin', caja);
      }
    }

    var c = contenido(total);
    caja.innerHTML = c.html;
    caja.classList.toggle('mt-cart__goal--ok', c.ok);
  }

  function actualizar() {
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { inyectar(c.total_price); })
      .catch(function () {});
  }

  // El tema re-renderiza el cajon completo: hay que volver a inyectar.
  function vigilar() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    new MutationObserver(function () {
      if (!cajon.querySelector('[' + MARCA + ']')) actualizar();
    }).observe(cajon, { childList: true, subtree: true });
  }

  var fetchOriginal = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    var esCarrito = typeof url === 'string' && url.indexOf('/cart/') !== -1;
    return fetchOriginal.apply(this, arguments).then(function (respuesta) {
      if (esCarrito) setTimeout(actualizar, 120);
      return respuesta;
    });
  };

  function iniciar() {
    actualizar();
    vigilar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
